// extracted by mini-css-extract-plugin
export default {"container":"AddressInformation_container__wHMhe","infoTopic":"AddressInformation_infoTopic__mmuhd"};